const ADMIN_TOKEN_KEY = "adminAuthToken";

export function getAdminToken(): string | null {
  return sessionStorage.getItem(ADMIN_TOKEN_KEY);
}

export function setAdminToken(token: string): void {
  sessionStorage.setItem(ADMIN_TOKEN_KEY, token);
}

export function clearAdminToken(): void {
  sessionStorage.removeItem(ADMIN_TOKEN_KEY);
}

export function isAdminAuthenticated(): boolean {
  return Boolean(getAdminToken());
}

/** 관리자 API 호출용 Authorization 헤더 (토큰 없으면 빈 객체) */
export function adminAuthHeaders(): Record<string, string> {
  const token = getAdminToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/** API `result`에서 토큰 문자열 추출 */
export function tokenFromLoginResult(result: unknown): string | null {
  if (typeof result === "string" && result.length > 0) {
    return result;
  }
  if (result && typeof result === "object") {
    const o = result as Record<string, unknown>;
    const access = o.accessToken;
    if (typeof access === "string" && access.length > 0) return access;
  }
  return null;
}
